import AppointmentTable from "./AppointmentTable";
export default AppointmentTable;